import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OutroVinculo } from "app/model/outroVinculo";
import { environment } from "environments/environment";
import { Observable } from "rxjs-compat";

@Injectable({
    providedIn: 'root'
})
export class OutroVinculoService {

    constructor(private http: HttpClient) { }

    private path = environment.url + 'api/v1/outro-vinculo';

    obterVinculos(): Observable<OutroVinculo[]> {
        return this.http.get<OutroVinculo[]>(this.path)
    }

    adicionarVinculo(outrosVinculos: OutroVinculo[]): Observable<OutroVinculo[]> {
        return this.http.post<OutroVinculo[]>(this.path, outrosVinculos)
    }

    deletarVinculo(id: number) {
        return this.http.delete(this.path + '/' + id)
    }
}